import React from 'react';
import MenuItem from 'app/shared/layout/menus/menu-item';
import { Translate, translate } from 'react-jhipster';
import { NavDropdown } from './menu-components';
import { faChartBar, faCoins, faExchangeAlt, faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons';

const dashboardMenuItemsAuthenticated = (
  <>
    <MenuItem icon={faChartBar} to="/finances" data-cy="financeItem">
      <Translate contentKey="global.menu.admin.dashboard">Dashboard</Translate>
    </MenuItem>
    <MenuItem icon={faHandHoldingUsd} to="/approvisonnements" data-cy="approItem">
      <Translate contentKey="global.menu.admin.approvisionnement">Approvisionnement</Translate>
    </MenuItem>
    <MenuItem icon={faExchangeAlt} to="/virements" data-cy="virementItem">
      <Translate contentKey="global.menu.admin.virement">Transactions</Translate>
    </MenuItem>
  </>
);

export const FinanceMenu = ({ isAuthenticated = false }) => (
  <NavDropdown icon={faCoins} name={translate('global.menu.admin.finance')} id="finance-menu" data-cy="financeMenu">
    {isAuthenticated && dashboardMenuItemsAuthenticated}
  </NavDropdown>
);

export default FinanceMenu;
